function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { Link, decayingInterval, formatRelativeDate, formatDateTime } from '@hypothesis/frontend-shared';
import classnames from 'classnames';
import { useEffect, useMemo, useState } from 'preact/hooks';

/**
 * `subtle`: Small text with inherited font weight.
 * `prominent`: Bold text with inherited font size.
 * `highlighted`: Brand red text with inherited font size.
 */
import { jsxs as _jsxs, jsx as _jsx } from "preact/jsx-runtime";
/**
 * Render textual timestamp information for an annotation. This includes
 * a relative date string (e.g. "5 hours ago") for the annotation's creation,
 * and, if `withEditedTimestamp` is `true`, a relative date string for when it
 * was last edited. If the `annotation` has an HTML link, the created-date
 * timestamp will be linked to that URL (the single-annotation view
 * for this annotation).
 */
export default function AnnotationTimestamps(_ref) {
  var annotationCreated = _ref.annotationCreated,
    annotationUpdated = _ref.annotationUpdated,
    annotationURL = _ref.annotationURL,
    withEditedTimestamp = _ref.withEditedTimestamp;
  // "Current" time, used when calculating the relative age of `timestamp`.
  var _useState = useState(function () {
      return new Date();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    now = _useState2[0],
    setNow = _useState2[1];
  var createdDate = useMemo(function () {
    return new Date(annotationCreated);
  }, [annotationCreated]);
  var updatedDate = useMemo(function () {
    return withEditedTimestamp && new Date(annotationUpdated);
  }, [annotationUpdated, withEditedTimestamp]);
  var created = useMemo(function () {
    return {
      absolute: formatDateTime(createdDate, {
        includeWeekday: true
      }),
      relative: formatRelativeDate(createdDate, now)
    };
  }, [createdDate, now]);
  var updated = useMemo(function () {
    if (!updatedDate) {
      return {};
    }
    return {
      absolute: formatDateTime(updatedDate, {
        includeWeekday: true
      }),
      relative: formatRelativeDate(updatedDate, now)
    };
  }, [updatedDate, now]);

  // Refresh relative timestamp, at a frequency appropriate for the age.
  useEffect(function () {
    // Determine which of the two Dates to use for the `decayingInterval`
    // It should be the latest relevant date, as the interval will be
    // shorter the closer the date is to "now"
    var laterDate = updatedDate ? annotationUpdated : annotationCreated;
    var cancelRefresh = decayingInterval(laterDate, function () {
      return setNow(new Date());
    });
    return cancelRefresh;
  }, [annotationCreated, annotationUpdated, createdDate, updatedDate, now]);

  // Do not show the relative timestamp for the edited date if it is the same
  // as the relative timestamp for the created date
  var editedString = updated && updated.relative !== created.relative ? "edited ".concat(updated.relative) : 'edited';
  var editedTimestampVariant = typeof withEditedTimestamp === 'string' ? withEditedTimestamp : 'subtle';
  return _jsxs("div", {
    children: [withEditedTimestamp && _jsxs("span", {
      className: classnames('italic', {
        'text-color-text-light': editedTimestampVariant !== 'highlighted',
        'text-brand': editedTimestampVariant === 'highlighted',
        'text-xs': editedTimestampVariant === 'subtle',
        'font-bold': editedTimestampVariant === 'prominent'
      }),
      "data-testid": "timestamp-edited",
      "data-variant": editedTimestampVariant,
      title: updated.absolute,
      children: ["(", editedString, ")", ' ']
    }), annotationURL ? _jsx(Link
    // The light-text hover color is not a standard color for a Link, so
    // LinkBase is used here
    , {
      classes: "text-color-text-light hover:text-color-text-light",
      target: "_blank",
      title: created.absolute,
      href: annotationURL,
      underline: "hover",
      variant: "custom",
      children: created.relative
    }) : _jsx("span", {
      className: "color-text-color-light",
      "data-testid": "timestamp-created",
      title: created.absolute,
      children: created.relative
    })]
  });
}
//# sourceMappingURL=AnnotationTimestamps.js.map